import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getIvas,
  getIvaDescripciones,
  updateIvaDescripciones,
  insertIvaDescripciones,
  deleteIvaDescripciones,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_IVAS() {
  try {
    const ivasData = yield call(getIvas)
    if (ivasData.ok) {
      yield put({
        type: actions.IVAS_LOAD_SUCCEEDED,
        payload: ivasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar iva')
      put({
        type: actions.IVAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.IVAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_IVA_DESCRIPCIONES() {
  try {
    const ivaDescripcionData = yield call(getIvaDescripciones)
    if (ivaDescripcionData.ok) {
      yield put({
        type: actions.IVAS_DESCRIPCION_LOAD_SUCCEEDED,
        payload: ivaDescripcionData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar iva descripción')
      put({
        type: actions.IVAS_DESCRIPCION_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.IVAS_DESCRIPCION_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_IVA_DESCRIPCIONES(action) {
  try {
    const estadoObj = yield call(insertIvaDescripciones, action.payload)
    if (estadoObj.ok) {
      putMessage(messageType.SUCCESS, 'Descripcion creada correctamente')
      yield put({
        type: actions.IVA_DESCRIPCION_INSERT_SUCCEEDED,
        payload: estadoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Descripcion')
      yield put({
        type: actions.IVA_DESCRIPCION_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Descripcion')
    yield all([
      put({
        type: actions.IVA_DESCRIPCION_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_IVA_DESCRIPCIONES(action) {
  try {
    const estadoObj = yield call(updateIvaDescripciones, action.payload)
    if (estadoObj.ok) {
      putMessage(messageType.SUCCESS, 'Descripcion modificada correctamente')
      yield put({
        type: actions.IVA_DESCRIPCION_UPDATE_SUCCEEDED,
        payload: estadoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar descripcion')
      yield put({
        type: actions.IVA_DESCRIPCION_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar descripcion')
    yield all([
      put({
        type: actions.IVA_DESCRIPCION_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_IVA_DESCRIPCIONES(action) {
  try {
    const estadoResult = yield call(deleteIvaDescripciones, action.id)
    if (estadoResult.ok) {
      putMessage(messageType.SUCCESS, 'Descripcion eliminado correctamente')
      yield put({
        type: actions.IVA_DESCRIPCION_DELETE_SUCCEEDED,
        id: action.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Descripcion')
      yield put({
        type: actions.IVA_DESCRIPCION_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Descripcion')
    yield all([
      put({
        type: actions.IVA_DESCRIPCION_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.IVAS_LOAD_REQUESTED, GET_IVAS),
    takeEvery(actions.IVAS_DESCRIPCION_LOAD_REQUESTED, GET_IVA_DESCRIPCIONES),
    takeEvery(actions.IVA_DESCRIPCION_INSERT_REQUESTED, INSERT_IVA_DESCRIPCIONES),
    takeEvery(actions.IVA_DESCRIPCION_UPDATE_REQUESTED, UPDATE_IVA_DESCRIPCIONES),
    takeEvery(actions.IVA_DESCRIPCION_DELETE_REQUESTED, DELETE_IVA_DESCRIPCIONES),
  ])
}
